import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Lock, Loader2, Mail } from "lucide-react";

const API = "/api";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_solar-config/artifacts/j8etyapd_ChatGPT%20Image%2026%20feb%202026%2C%2011_13_48.png";

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      onLogin(res.data.token);
      toast.success("Accesso effettuato");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-10 max-w-sm w-full">
        <div className="flex justify-center mb-6">
          <img src={LOGO_URL} alt="Logo" className="h-16 w-auto" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 text-center mb-1" style={{ fontFamily: "Outfit, sans-serif" }} data-testid="admin-login-title">
          Admin Dashboard
        </h1>
        <p className="text-sm text-slate-500 text-center mb-6">Accedi per gestire il pannello</p>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                type="email"
                placeholder="Inserisci la tua email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-11 rounded-xl pl-10 input-focus-ring"
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                type="password"
                placeholder="Inserisci la password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-11 rounded-xl pl-10 input-focus-ring"
                data-testid="admin-password-input"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading || !email || !password}
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl py-3 text-sm disabled:opacity-50 flex items-center justify-center gap-2 btn-scale"
            data-testid="admin-login-button"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Accedi
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
